"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/toConsumableArray"));

var _workOrderConsult = require("@/api/workOrderConsult");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'selectConsult',
  data: function data() {
    return {
      listLoading: true,
      listConsults: null,
      //咨询项
      listComplains: null,
      //投诉项
      showConsults: [],
      //需要展示的咨询项
      dialogFormVisible: false,
      assignedConsults: [],
      //当ticketId不为空时 此值有内容 
      assignedConsultsName: [],
      //
      consultType: '',
      //传参：咨询项内容(显示咨询还是投诉 如果空 显示所有) 0咨询 1投诉
      ticketId: '',
      //传参：工单编号 如果不为空 需要加载已选择的咨询项
      limit: 0,
      //传参： 0不限制数量 否则按limit数量限制 
      isLoaded: false
    };
  },
  methods: {
    show: function show(type, ticketId, limit) {
      var _this = this;

      if (this.isLoaded) {
        this.dialogFormVisible = true;
        return;
      }

      if (this.listConsults && this.listConsults.length > 0) this.treeInit(type, ticketId, limit);else {
        this.listLoading = true;
        (0, _workOrderConsult.listConsults)().then(function (response) {
          _this.listConsults = response.data.data.consults;
          _this.listComplains = response.data.data.complains;
          _this.listLoading = false;

          _this.treeInit(type, ticketId, limit);
        }).catch(function () {
          _this.listConsults = [];
          _this.listLoading = false;
        });
      }
    },
    treeInit: function treeInit(type, ticketId, limit) {
      var _this2 = this;

      this.consultType = type;
      this.ticketId = ticketId;
      this.limit = limit;
      if (type == 0) //咨询项
        this.showConsults = this.listConsults;else if (type == 1) //投诉项
        this.showConsults = this.listComplains;else //全部
        this.showConsults = [].concat((0, _toConsumableArray2.default)(this.listConsults), (0, _toConsumableArray2.default)(this.listComplains)); //必须先显示

      this.dialogFormVisible = true; //初始值

      this.assignedConsults = [];
      this.assignedConsultsName = [];
      setTimeout(function () {
        _this2.$refs.tree.setCheckedKeys([]);
      }, 1);
      this.isLoaded = true;
    },
    handleSelected: function handleSelected() {
      //this.$parent.bookTradeNoChange(this.bookInfo); 

      /*if (this.assignedConsults.length == 0) {
          this.$notify.warning({
              title: '提醒',
              message: '请至少选择一个问题'
          })
          return;
      }*/
      var size = this.$refs.tree.getCheckedKeys(true).length;

      if (this.limit > 0 && size > this.limit) {
        this.$notify.warning({
          title: '提醒',
          message: '超过限定数量' + this.limit + '，请调整'
        });
        return;
      }

      if (this.$parent.handleSelectedConsult) this.$parent.handleSelectedConsult(this.assignedConsults, this.assignedConsultsName);
      this.dialogFormVisible = false;
    },
    handleNodeChange: function handleNodeChange(node, checked) {
      // console.info(node)
      // console.info(checked)
      if (checked.checkedNodes.length > 0) {
        var size = this.$refs.tree.getCheckedKeys(true).length;

        if (this.limit > 0 && size > this.limit) {
          this.$notify.warning({
            title: '提醒',
            message: '超过限定' + this.limit + '数量，请调整'
          });
        }
      } //选中项的名称


      var assignedConsultsName = [];

      for (var i = 0; i < checked.checkedNodes.length; i++) {
        var _node = checked.checkedNodes[i];
        if (!_node.children) assignedConsultsName.push(_node.path);
      }

      this.assignedConsultsName = assignedConsultsName;
      this.assignedConsults = this.$refs.tree.getCheckedKeys(true);
    }
  }
};
exports.default = _default;